import { apiRequest } from "services/apiService";

export const getPortals = () => async (dispatch) => {
    try {
        dispatch({ type: "PORTALS_LOADING" });
        const data = await apiRequest("/portals");
        dispatch({ type: "PORTALS_SUCCESS", payload: data });
    } catch (error) {
        dispatch({ type: "PORTALS_ERROR", payload: error.message });
    } 
};

export const getPortalTodoCounts = (workItemCountModel) => async (dispatch) => {
    try {
        dispatch({ type: "PORTAL_COUNTS_LOADING" });

        const query = new URLSearchParams({
            id: workItemCountModel.id,
            status: workItemCountModel.status
        }).toString();

        const data = await apiRequest(`/workitems/count?${query}`); 
        dispatch({ type: "PORTAL_COUNTS_SUCCESS", payload: data });

        return data;
    } catch (error) {
        dispatch({ type: "PORTAL_COUNTS_ERROR", payload: error.message });
        throw error;
    }
};
